import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useHistoryStyles = createUseStyles((theme: ITheme) => ({
  container: ({ isDarkMode }) => {
    const styleGl = {
      display: 'inline-block',
      cursor: 'pointer',
      borderRadius: theme.radiuses.r4,
    };

    if (!isDarkMode) {
      return {
        ...styleGl,
        padding: `11px 10px ${theme.spacings.s4} 10px`,
        width: 58,
        marginLeft: 16,
        marginRight: 16,
        border: '1px solid #dcdde9',
      };
    }

    return {
      ...styleGl,
      width: 70,
      height: 64,
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      margin: `${theme.spacings.s0} auto`,
    };
  },
  containerInvertHover: ({ isDarkMode }) => {
    if (!isDarkMode) {
      return {
        '&:hover': {
          color: '#3a76e8',
          '& path': {
            fill: '#282b36',
          },
          '& p': {
            color: '#282b36',
          },
          border: '1px solid #282b36',
        },
      };
    }

    return {
      '&:hover': {
        color: theme.colors.texts.base,
        backgroundColor: theme.colors.backgrounds.tint2,
        borderRadius: theme.radiuses.r8,
        '& path': {
          fill: theme.colors.texts.base,
        },
        '& p': {
          color: theme.colors.texts.base,
        },
      },
    };
  },
  containerResetHover: ({ isDarkMode }) => {
    if (!isDarkMode) {
      return {
        '&:hover': {
          color: '#3a76e8',
          '& svg>g>path:first-child': {
            fill: '#282b36',
          },
          '& path': {
            fill: '#282b36',
          },
          '& p': {
            color: '#282b36',
          },
          border: '1px solid #282b36',
        },
      };
    }

    return {
      '&:hover': {
        color: theme.colors.texts.base,
        backgroundColor: theme.colors.backgrounds.tint2,
        borderRadius: theme.radiuses.r8,
        '& svg>g>path:first-child': {
          fill: theme.colors.texts.base,
        },
        '& path': {
          fill: theme.colors.texts.base,
        },
        '& p': {
          color: theme.colors.texts.base,
        },
      },
    };
  },
  containerDisabledHover: {
    ...theme.variables.effectItemDisabledState,
  },
  containerDisabled: {
    ...theme.variables.effectItemNotClickableState,
    opacity: 0.5,
  },
  hoverIconContainer: {
    border: '1px solid #282b36',
  },
  toolIconName: {
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '16px',
    color: '#545869',
    marginTop: theme.spacings.s0,
  },
  historyToolIcons: {
    verticalAlign: 'top',
    display: 'inline-block',
    width: theme.variables.iconSize,
    height: theme.variables.iconSize,
    '& path': {
      fill: theme.colors.texts.tint1,
    },
  },
  tooltipContainer: {
    marginTop: ({ isDarkMode }) => !isDarkMode ? 16 : 0,
  },
  sidebarTooltipItem: {
    marginTop: `${theme.spacings.s4}`,
  },
}));

export default useHistoryStyles;
